// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2MWc3","head":"Table_head__2WsiV","col":"Table_col__3JWy0"};